import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function authHeaders() {
  const token = localStorage.getItem("arnav_admin_token");
  return token ? { "X-Admin-Token": token } : {};
}

export async function listProducts() {
  const { data } = await api.get("/products");
  return data;
}

export async function getProduct(id) {
  const { data } = await api.get(`/products/${id}`);
  return data;
}

export async function createProduct(payload) {
  const { data } = await api.post("/products", payload, { headers: authHeaders() });
  return data;
}

export async function updateProduct(id, payload) {
  const { data } = await api.put(`/products/${id}`, payload, { headers: authHeaders() });
  return data;
}

export async function deleteProduct(id) {
  const { data } = await api.delete(`/products/${id}`, { headers: authHeaders() });
  return data;
}

export async function submitInquiry(payload) {
  const { data } = await api.post("/inquiries", payload);
  return data;
}

export async function listInquiries() {
  const { data } = await api.get("/inquiries", { headers: authHeaders() });
  return data;
}

export async function deleteInquiry(id) {
  const { data } = await api.delete(`/inquiries/${id}`, { headers: authHeaders() });
  return data;
}

export async function getSettings() {
  const { data } = await api.get("/settings");
  return data;
}

export async function updateSettings(payload) {
  const { data } = await api.put("/settings", payload, { headers: authHeaders() });
  return data;
}

export async function adminLogin(password) {
  const { data } = await api.post("/admin/login", { password });
  return data;
}

export async function listGallery() {
  const { data } = await api.get("/gallery");
  return data;
}

export async function createGalleryItem(payload) {
  const { data } = await api.post("/gallery", payload, { headers: authHeaders() });
  return data;
}

export async function updateGalleryItem(id, payload) {
  const { data } = await api.put(`/gallery/${id}`, payload, { headers: authHeaders() });
  return data;
}

export async function deleteGalleryItem(id) {
  const { data } = await api.delete(`/gallery/${id}`, { headers: authHeaders() });
  return data;
}

export async function sendTestAlert() {
  const { data } = await api.post("/inquiries/test-alert", {}, { headers: authHeaders() });
  return data;
}

export async function listTestimonials() {
  const { data } = await api.get("/testimonials");
  return data;
}

export async function createTestimonial(payload) {
  const { data } = await api.post("/testimonials", payload, { headers: authHeaders() });
  return data;
}

export async function updateTestimonial(id, payload) {
  const { data } = await api.put(`/testimonials/${id}`, payload, { headers: authHeaders() });
  return data;
}

export async function deleteTestimonial(id) {
  const { data } = await api.delete(`/testimonials/${id}`, { headers: authHeaders() });
  return data;
}

export async function uploadImage(file, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads/image", fd, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return data; // { id, url, content_type, size }
}

export async function uploadVideo(file, onProgress) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads/video", fd, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return data;
}

export function fileUrl(pathOrUrl) {
  // If backend returns a relative path like "/api/files/xyz", prefix with BACKEND_URL
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http") || pathOrUrl.startsWith("data:")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return `${BACKEND_URL}${pathOrUrl}`;
  return pathOrUrl;
}
